<template>
  <div>
    <headers />
    <div class="strip">
      <div class="bgmap"></div>
      <div class="bg"></div>
      <div class="turn clearfix containers">
        <div class="searbox" style="margin:auto;width:839px">
          <el-input placeholder="请输入关键词" v-model="input3" class="input-with-select" @change= 'search'>
            <el-button slot="append" type="primary" @click="search" style="border-radius:0">搜索</el-button>
          </el-input>
        </div>
      </div>
    </div>
    <div class="containers searchss" v-if="searcharr != null">
      <div class="number">
        共{{gong==NaN?0:gong}}条
        <i>{{jg_inputs}}</i>相关的结果
      </div>
      <div class="chooseboxleft" style="padding:0">
        <div class="tabbox on">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label="'课程信息('+searcharr.video_count+')'" name="0"></el-tab-pane>
            <el-tab-pane :label="'讲师信息('+searcharr.teacher_count+')'" name="1"></el-tab-pane>
            <el-tab-pane :label="'机构信息('+searcharr.school_count+')'" name="2"></el-tab-pane>
          </el-tabs>
        </div>
        <!-- 课程信息 -->
        <div v-show="activeName==0 && searcharr.video_list.length!=0">
          <div
            class="classitems clearfix"
            v-for="(item) in searcharr.video_list"
            :data-id="item.id"
            :key="item.id"
          >
            <div class="pic fl">
              <img :src="item.imgUrl" alt />
              <div class="type" v-if="item.type == 1">点播课</div>
              <div class="type" v-if="item.type == 2">直播课</div>
              <div class="type" v-if="item.type == 3">线下课</div>
            </div>
            <div class="infos clearfix fr">
              <h3>{{item.title}}</h3>
              <div class="zai">
                <i class="el-icon-s-custom"></i>
                {{item.count}}人在学
              </div>
              <div class="hou clearfix">
                <div class="money fl">{{item.price == 0?'免费':'￥'+item.price}}</div>
                <router-link
                  tag="div"
                  to="/detailsclass"
                  class="btn fr on"
                  v-if="item.isJoin == 1"
                >去学习</router-link>
                <router-link
                  tag="div"
                  :to="{path:'/detailsclass',query:{id:item.id}}"
                  class="btn fr"
                  v-else
                >立即参加</router-link>
              </div>
            </div>
          </div>
          <div class="pageing">
            <span class="spansx" @click="k_pageindex" :class="[page == 1?'on':'']">首页</span>
            <el-pagination
              small
              layout="prev, pager, next"
              prev-text="上一页"
              next-text="下一页"
              :background="true"
              :total="searcharr.video_total_pages==null?1:searcharr.video_total_pages"
              :page-size="1"
              @current-change="k_currentchange"
              :current-page="page"
            ></el-pagination>
            <span @click="k_pageend" class="spansx" :class="[page == searcharr.video_total_pages?'on':'']">尾页</span>
          </div>
        </div>
        <!-- 课程信息结束 -->

        <!-- 讲师信息 -->
        <div v-show="activeName == 1 && searcharr.teacher_list.length!=0">
          <div class="teacherinfor">
            <ul>
              <router-link
                tag="li"
                :to="{path:'/teacherdetails',query:{id:item.id}}"
                class="clearfix"
                v-for="(item) in searcharr.teacher_list"
                :data-id="item.id"
                :key="item.id"
              >
                <div class="pic">
                  <img :src="item.avatar" alt srcset />
                </div>
                <div class="infos">
                  <div class="name">{{item.name}}</div>
                  <div class="men">
                    <i>{{item.courseCount}}</i>门课 |
                    <i>{{item.collectCount}}</i>人关注
                  </div>
                  <div class="shu">所属机构：{{item.school_name}}</div>
                  <div class="rate" v-if="item.score != undefined">
                    讲师评分：
                    <el-rate
                      v-model="item.score"
                      disabled
                      show-score
                      text-color="#ff9900"
                      :score-template="(item.score.toString())"
                      class="elrate"
                    ></el-rate>
                  </div>
                </div>
              </router-link>
            </ul>
            <div class="pageing">
              <span class="spansx" @click="t_pageindex" :class="[page == 1?'on':'']">首页</span>
              <el-pagination
                small
                layout="prev, pager, next"
                prev-text="上一页"
                next-text="下一页"
                :background="true"
                :total="searcharr.teacher_total_pages==null?1:searcharr.teacher_total_pages"
                :page-size="1"
                @current-change="t_currentchange"
                :current-page="page"
              ></el-pagination>
              <span @click="t_pageend" class="spansx" :class="[page == searcharr.teacher_total_pages?'on':'']">尾页</span>
            </div>
          </div>
        </div>
        <!-- 机构信息 -->
        <div v-show="activeName == 2 && searcharr.school_list.length!=0">
          <div class="teacherinfor">
            <ul>
              <router-link
                tag="li"
                :to="{path:'/medetails',query:{id:item.id}}"
                class="clearfix"
                v-for="(item) in searcharr.school_list"
                :data-id="item.id"
                :key="item.id"
              >
                <div class="pic">
                  <img :src="item.avatar" alt srcset />
                </div>
                <div class="infos">
                  <div class="name">{{item.name}}</div>
                  <div class="men">
                    课程数：
                    <i>{{item.courseCount}}</i>
                    <span></span>
                    关注人数：
                    <i>{{item.teacherCount}}</i>
                  </div>
                  <div class="rate">
                    讲师评分：
                    <el-rate
                      v-model="item.score"
                      disabled
                      show-score
                      text-color="#ff9900"
                      score-template="{value}"
                      class="elrate"
                    ></el-rate>
                  </div>
                </div>
              </router-link>
            </ul>
            <div class="pageing">
              <span class="spansx" @click="pageindex" :class="[page == 1?'on':'']">首页</span>
              <el-pagination
                small
                layout="prev, pager, next"
                prev-text="上一页"
                next-text="下一页"
                :background="true"
                :total="searcharr.school_total_pages==null?1:searcharr.school_total_pages"
                :page-size="1"
                @current-change="currentchange"
                :current-page="page"
              ></el-pagination>
              <span @click="pageend" class="spansx" :class="[page == searcharr.school_total_pages?'on':'']">尾页</span>
            </div>
          </div>
        </div>

        <!-- 机构信息结束 -->
      </div>
      <div class="chooseboxr">
        <div class="hotsearch">
          <h3>热门搜索</h3>
          <div class="spanlist clearfix">
            <span v-for="(item,index) in keylist" :key="index" @click="remne(item.keyword)">{{item.keyword}}</span>
          </div>
        </div>
        <div class="tuibox">
          <h3>推荐课程</h3>
          <router-link
            tag="div"
            :to="{path:'/detailsclass',query:{id:item.id}}"
            class="item clearfix"
            v-for="(item) in searcharr.hot_course"
            :key="item.id"
            :data-id="item.id"
          >
            <div class="pic">
              <img :src="item.imgUrl" />
            </div>
            <div class="infos">
              <h4>{{item.title}}</h4>
              <span v-if="item.type == 1">点播课</span>
              <span v-if="item.type == 2">直播课</span>
              <span v-if="item.type == 3">线下课</span>
              <div class="money">{{item.price == 0?'免费':'￥'+item.price}}</div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div v-else style=" text-align: center; margin-top:60px;">
      <i style="font-size:160px;" class="iconfont icon-zanwushuju"></i>
    </div>
  </div>
</template>

<script>
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import utilFile from "@/ace/ace.js";
import getPointNum from "@/tools/tools.js";
import {
  Input,
  Button,
  Rate,
  Tabs,
  TabPane,
  Icon,
  Pagination
} from "element-ui";
export default {
  components: {
    headers,
    footers,
    [Input.name]: Input,
    [Button.name]: Button,
    [Rate.name]: Rate,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Icon.name]: Icon,
    [Pagination.name]: Pagination
  },
  data() {
    return {
      input3: "",
      activeName: 0,
      value: 3,
      locallist: [], //搜索历史
      searcharr: null,
      gong: 0,
      keylist: [],
      page: 1,
      total_pages: 0,
      jg_inputs:'',
    };
  },
  inject: ["reload"], // 引入方法
  watch: {
    activeName() {
      this.page = 1;
    },
 
    '$route'(to,from) {
      //同一个页面刷新
      if (to.query.keywords) {
        this.input3 = to.query.keywords;
        this.search();
        
      }
    },
    page(page){
      this.search();
    },
  },
  methods: {
    //分页 机构
    currentchange(page) {
      this.page = page;
    },
    pageindex() {
      this.page = 1;
    },
    pageend() {
      this.page = this.searcharr.school_total_pages;
    },
    //分页 教师
    t_currentchange(page) {
      this.t_page = page;
    },
    t_pageindex() {
      this.page = 1;
    },
    t_pageend() {
      this.page = this.searcharr.teacher_total_pages;
    },
    //分页 课程
    k_currentchange(page) {
      this.page = page;
    },
    k_pageindex() {
      this.page = 1;
    },
    k_pageend() {
      this.page = this.searcharr.video_total_pages;
    },



    handleClick(tab, event) {
      console.log(tab, event);
    },
    remne(hot){
      this.input3 = hot;
      this.search();
    },
    search() {
      let arr = [];
      this.locallist.push(this.input3);
      if (localStorage.locallist) {
        arr = localStorage.locallist.split(",");
      } else {
        arr = [];
      }
      arr.push(this.input3);
      localStorage.setItem("locallist", arr);

      var data = {
        keyword: this.input3,
        page:this.page,
      };

      data = utilFile.encrypt(JSON.stringify(data));

      this.$axios({
        method: "post",
        url: `/index/home.search?parameter=${data}`,
        data: {},
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        let totaldata = JSON.parse(utilFile.decrypt(res.data.data));

        this.jg_inputs = this.input3;//搜索结果

        this.gong =
          totaldata.school_count +
          totaldata.teacher_count +
          totaldata.video_count;
        this.searcharr = totaldata;
        this.searcharr.teacher_list.forEach(item => {
          item.score = getPointNum.getPointNum(item.score, 2);
        });
        this.searcharr.school_list.forEach(item => {
          item.score = getPointNum.getPointNum(item.score, 2);
        });

      });
    },
    hotsearch() {
      this.$axios({
        method: "post",
        url: `/api/home.getSearchConfig`,
        data: {},
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        let totaldata = JSON.parse(utilFile.decrypt(res.data.data));
        this.keylist = totaldata;
      });
    },

  },
  mounted() {
    this.hotsearch();
    if(this.$route.query.keywords){
      this.input3 = this.$route.query.keywords;
      this.search();
    }
  }
};
</script>

<style scoped>
@import "~@/assets/css/common.css";
.searchss .number {
  text-align: center;
  font-size: 16px;
  color: #000000;
  margin-top: 33px;
  margin-bottom: 33px;
  text-align: left;
  font-weight: 600;
}

.searchss .number i {
  color: #ff0a0a;
}

.searchss .teacherinfor {
  box-sizing: border-box;
  padding: 22px 37px;
}

.searchss .teacherinfor li {
  padding-bottom: 26px;
  padding-top: 26px;
  border-bottom: 1px solid #edf1f2;
}

.searchss .teacherinfor li .pic {
  width: 142px;
  height: 142px;
  border-radius: 50%;
  overflow: hidden;
  float: left;
}

.searchss .teacherinfor li .pic img {
  height: 100%;
}

.searchss .teacherinfor li .infos {
  float: left;
  margin-left: 25px;
  text-align: left;
}

.searchss .teacherinfor li .infos .name {
  font-size: 18px;
  color: #1b1f22;
  margin-bottom: 19px;
}

.searchss .teacherinfor li .infos .men {
  font-size: 14px;
  color: #000000;
  margin-bottom: 13px;
}

.searchss .teacherinfor li .infos .men span {
  margin: 0 14px;
}

.searchss .teacherinfor li .infos .men i {
  color: #ff0d0d;
  font-weight: bold;
  margin-bottom: 13px;
}

.searchss .teacherinfor li .infos .shu {
  font-size: 14px;
  color: #000000;
  margin-bottom: 30px;
}

.searchss .teacherinfor li .infos .rate .elrate {
  display: inline-block;
  vertical-align: middle;
}


</style>
<style>
.searchss .teacherinfor li .infos .el-rate__text {
  color: #ff0a0a !important;
  font-weight: bold;
  font-size: 18px;
}

</style>